import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { TrashIcon } from "@heroicons/vue/24/outline";
import { EllipsisVerticalIcon } from "@heroicons/vue/24/solid";

import { useI18n } from "vue-i18n";
import { useDeleteOrganization } from "shared/composables/organization";
import { useConfirmationModal } from "shared/composables/toast";
import { Organization } from "shared/types/Organization";
import BasicMenu from "@/components/other/BasicMenu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationsViewMenu',
  props: {
    selectedOrganization: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const { deleteOrganization } = useDeleteOrganization();
const showConfirmationModal = useConfirmationModal();

const handleDeleteOrganizationClick = () => {
  if (!props.selectedOrganization) {
    return;
  }
  showConfirmationModal({
    confirmAction: t("organizations.delete_confirmation.confirm"),
    cancelAction: t("organizations.delete_confirmation.cancel"),
    message: t("organizations.delete_confirmation.message", {
      name: props.selectedOrganization.name,
    }),
    header: t("organizations.delete_confirmation.header"),
  }).then((confirmed) => {
    if (confirmed && props.selectedOrganization) {
      deleteOrganization(props.selectedOrganization._id).catch(() => undefined);
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasicMenu, { position: "left" }, {
    icon: _withCtx(() => [
      _createVNode(_unref(EllipsisVerticalIcon), {
        class: "h-8 w-8",
        "aria-hidden": "true"
      })
    ]),
    content: _withCtx(({ item }) => [
      (_ctx.selectedOrganization)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
            key: 0,
            onClick: handleDeleteOrganizationClick
          }, {
            default: _withCtx(({ active }) => [
              _createElementVNode("div", {
                class: _normalizeClass([
            active ? 'bg-gray-100 text-red-600' : 'text-gray-700',
            'px-4 py-2 cursor-pointer whitespace-nowrap flex items-center',
          ])
              }, [
                _createVNode(_unref(TrashIcon), { class: "h-4 w-4 mr-1" }),
                _createElementVNode("span", null, _toDisplayString(_unref(t)("organizations.delete_organization")), 1)
              ], 2)
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})